import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import { useEffect, useState } from "react";

// 1. named import & export
// 2. default export & import - only one default export per file

// hook - useState - hook are function - it will always starts with "use"
function Counter() {
  // const like = 1;

  // state - current scenario - current data - web app
  // const [state, setState] = useState(InitialValue);
  // like - state setState - setLike -> updates like

  const [like, setLike] = useState(0);
  const [disLike, setDisLike] = useState(0);
  const incrementLike = () => setLike(like + 1);
  const incrementDisLike = () => setDisLike(disLike + 1);

  useEffect(() => {
    console.log("The updated like value ", like);
  }, [like, disLike]);

  return (
    <div className="counter-container">
      <IconButton
        className="likes-dislikes"
        onClick={incrementLike}
        color="primary"
        aria-label="like"
      >
        <Badge badgeContent={like} color="primary">
          👍
        </Badge>
      </IconButton>

      <IconButton
        className="likes-dislikes"
        onClick={incrementDisLike}
        aria-label="dislike"
        color="error"
      >
        <Badge badgeContent={disLike} color="error">
          👎
        </Badge>
      </IconButton>

      {/* onClick - its pascal case - "C"  caps*/}
      {/* click like button
  -> onClick event
  -> setLike (will update like)
  -> React will update the like in the view (screen) */}
    </div>
  );
}

// // Its an normal function
function double(n) {
  return [n, n * 2];
}

export { Counter, double };

// export default Counter;
